import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/shoppingBagAdd.svg';

export const IconShoppingBagAdd = createIconComponent(Icon);
